// NotificationModal.js
import { Box, Button, Grow, Modal, Typography } from "@mui/material";
// import { useTheme } from "@mui/material/styles";
import { Link } from "react-router-dom";
import DotPagination from "components/DotPagination";
import { useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { notificationAction } from "redux/slice/notifications";
import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";
import badgeImageMap from "utils/Badges/badgeImageMap";
import CustomConfetti from "./components/CustomConfetti";

const NotificationModal = () => {
  const dispatch = useDispatch();
  // const theme = useTheme();
  const { modalOpen, awardedBadges } = useSelector((state) => state.notifications);
  const [currentIndex, setCurrentIndex] = useState(0);
  const modalRef = useRef(null);
  const animationDelay = 500;

  if (!awardedBadges || awardedBadges.length === 0) {
    return null;
  }

  const currentBadge = awardedBadges[currentIndex];

  const handleClose = () => {
    setCurrentIndex(0);
    dispatch(notificationAction.closeNotification(awardedBadges));
  };

  const handlePaginationChange = (value) => {
    setCurrentIndex(value);
  };

  const renderBadgeImage = (badgeImage) => (
    <img
      src={badgeImageMap[badgeImage]}
      alt={badgeImage}
      loading="lazy"
      style={{
        filter: "drop-shadow(4px 4px 6px rgba(0, 0, 0, 0.0))",
        maxHeight: "265px",
      }}
    />
  );

  return (
    <Modal open={modalOpen} onClose={handleClose} closeAfterTransition>
      <Box
        sx={{
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          outline: "none",
          overflow: "hidden",
          borderRadius: "0.75rem",
        }}
      >
        <Grow
          in={modalOpen}
          style={{ transformOrigin: "50% 50%" }}
          timeout={{ enter: animationDelay, exit: 0 }}
        >
          <Box
            ref={modalRef}
            sx={{
              backgroundColor: "#fff",
              boxShadow: 24,
              borderRadius: "0.75rem",
              p: 4,
              width: 400,
              height: 525,
              overflowX: "auto",
              display: "flex",
              alignItems: "center",
              flexDirection: "column",
            }}
          >
            {/* Gradient circle */}
            <Box
              sx={{
                position: "absolute",
                top: "-575px",
                left: "50%",
                transform: "translateX(-50%)",
                width: "800px",
                height: "800px",
                borderRadius: "50%",
                // background: "linear-gradient(135deg, #ff6a00, #f6c455)",
                background: "linear-gradient(135deg, #3d32a8, #3d32a8, #aa6bcc)",
                zIndex: 0,
                pointerEvents: "none",
                overflow: "hidden",
              }}
            >
              <CustomConfetti />
            </Box>

            <Box>{renderBadgeImage(currentBadge?.badge_image || null)}</Box>
            <Box sx={{ textAlign: "center", flexGrow: 1, mt: "-0.5rem" }}>
              <Typography
                sx={{
                  fontSize: "1.75rem",
                  fontWeight: "700",
                  color: "#5a636a",
                  letterSpacing: "0.5px",
                }}
              >
                Congratulations!
              </Typography>
              <Box display="flex" alignItems="baseline">
                <Typography variant="h6" sx={{ fontWeight: "400" }}>
                  You earned the
                  <span
                    style={{
                      color: "#ff9c3b",
                      fontSize: "1.1rem",
                      fontWeight: "700",
                      marginTop: "0.5rem",
                      padding: "0.25rem",
                    }}
                  >
                    {currentBadge.name}
                  </span>
                  badge
                </Typography>

                {/* <Typography variant="h6" sx={{ fontWeight: "400" }}>
                  badge
                </Typography> */}
              </Box>
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              {awardedBadges.length > 1 && (
                <DotPagination
                  dots={awardedBadges.length}
                  index={currentIndex}
                  onChangeIndex={handlePaginationChange}
                />
              )}
              <Button
                onClick={handleClose}
                variant="contained"
                sx={{
                  // backgroundColor: theme.palette.primaryRed.main,
                  background: "linear-gradient(to bottom right, #f6c455, #ff6a00)",
                  color: "#fff",
                  // "&:hover": {
                  //   backgroundColor: theme.palette.primaryRed.main,
                  // },
                  borderRadius: "2rem",
                  mt: "1rem",
                  mb: "0.5rem",
                }}
              >
                Congrats!
              </Button>
              <Link
                to="/trophy-cabinet"
                onClick={handleClose}
                style={{
                  "&:hover": {
                    cursor: "pointer",
                  },
                  display: "flex",
                  alignItems: "center",
                  color: "cornflowerblue",
                  fontSize: "0.85rem",
                }}
              >
                <ArrowRightAltIcon
                  sx={{
                    transform: "scale(-1.5, 1.5)",
                    mr: "0.5rem",
                  }}
                />
                See Trophy Cabinet
              </Link>
            </Box>
          </Box>
        </Grow>
      </Box>
    </Modal>
  );
};

export default NotificationModal;
